export const DRAWER_WIDTH = 280;
export const COLLAPSED_WIDTH = 65;
export const HEADER_HEIGHT = 64;

export const MENU_TRANSITION_DURATION = {
  enteringScreen: 300,
  leavingScreen: 300
};

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ko', label: '한국어' },
  { code: 'id', label: 'Bahasa Indonesia' }
];

export const DEPARTMENTS = [
  'Marketing',
  'Dyeing',
  'Production',
  'QC/QA',
  'Admin'
];

export const REGIONS = [
  'Korea',
  'Indonesia'
];

export const INITIAL_FORM_STATE = {
  fullName: '',
  userId: '',
  password: '',
  confirmPassword: '',
  department: '',
  region: '',
  initialStr: ''
};

export const ADMIN_MENUS = {
  title: 'menu.admin.title',
  icon: 'Settings',
  subMenus: [
    {
      title: 'menu.admin.userManagement.title',
      subMenus: [
        { title: 'menu.admin.userManagement.registration', path: '/main/admin/users/registration' },
        { title: 'menu.admin.userManagement.resetPassword', path: '/main/admin/users/reset-password' },
        { title: 'menu.admin.userManagement.accessLogs', path: '/main/admin/users/access-logs' },
        { title: 'menu.admin.userManagement.sendMessage', path: '/main/admin/users/send-message' }
      ]
    },
    {
      title: 'menu.admin.standardsManagement.title',
      subMenus: [
        { title: 'menu.admin.standardsManagement.threads', path: '/main/admin/standards/threads' },
        { title: 'menu.admin.standardsManagement.companies', path: '/main/admin/standards/companies' },
        { title: 'menu.admin.standardsManagement.buyers', path: '/main/admin/standards/buyers' },
        { title: 'menu.admin.standardsManagement.prices', path: '/main/admin/standards/prices' },
        { title: 'menu.admin.standardsManagement.sizes', path: '/main/admin/standards/sizes' }
      ]
    },
    {
      title: 'menu.admin.materialsManagement.title',
      subMenus: [
        { title: 'menu.admin.materialsManagement.yarn', path: '/main/admin/materials/yarn' },
        { title: 'menu.admin.materialsManagement.dye', path: '/main/admin/materials/dye' },
        { title: 'menu.admin.materialsManagement.inventory', path: '/main/admin/materials/inventory' }
      ]
    },
    {
      title: 'menu.admin.bi.title',
      path: '/main/admin/bi'
    }
  ]
};

export const getMenuStructure = (t, isAdmin = false) => {
  const baseMenu = [
    {
      title: t('menu.notices'),
      icon: 'Notifications',
      path: '/main/notices'
    },
    {
      title: t('menu.orderManagement'),
      icon: 'Assignment',
      subMenus: [
        { title: t('menu.orderInput'), path: '/main/orders/input' },
        { title: t('menu.dyeingSet'), path: '/main/orders/dyeing-set' },
        { title: t('menu.workOrder'), path: '/main/orders/work-order' },
        { title: t('menu.orderSearch') || '오더 검색', path: '/main/orders/search' }
      ]
    },
    {
      title: t('menu.dyeingManagement'),
      icon: 'Opacity',
      subMenus: [
        { title: t('menu.dyeingWork'), path: '/main/dyeing/work' },
        { title: t('menu.dyeingOperation'), path: '/main/dyeing/operation' },
        { title: t('menu.dyeingStatus'), path: '/main/dyeing/status' },
        { title: t('menu.recipeSearch'), path: '/main/dyeing/recipe-search' }
      ]
    },
    {
      title: t('menu.windingManagement'),
      icon: 'Build',
      subMenus: [
        { title: t('menu.windingRequest'), path: '/main/winding/request' },
        { title: t('menu.windingStatus'), path: '/main/winding/status' }
      ]
    },
    {
      title: t('menu.shippingDelivery'),
      icon: 'LocalShipping',
      subMenus: [
        { title: t('menu.shippingRequest'), path: '/main/shipping/request' },
        { title: t('menu.packaging'), path: '/main/shipping/packaging' },
        { title: t('menu.deliveryRequest'), path: '/main/shipping/delivery-request' },
        { title: t('menu.deliveryStatus'), path: '/main/shipping/delivery-status' }
      ]
    }
  ];

  if (isAdmin) {
    baseMenu.push({
      title: t('menu.admin.title'),
      icon: 'Settings',
      subMenus: ADMIN_MENUS.subMenus.map(submenu => ({
        title: t(submenu.title),
        subMenus: submenu.subMenus.map(item => ({
          title: t(item.title),
          path: item.path
        }))
      }))
    });
  }

  return baseMenu;
};

export const STATUS_COLORS = {
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
  pending: '#9e9e9e'
};

export const CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD' },
  { value: 'KRW', label: 'KRW' },
  { value: 'IDR', label: 'IDR' },
  { value: 'EUR', label: 'EUR' }
];

export const UNIT_OPTIONS = [
  { value: 'kg', label: 'kg' },
  { value: 'pc', label: 'pc' },
  { value: 'm', label: 'm' },
  { value: 'yd', label: 'yd' }
];

export const DATE_FORMATS = {
  display: 'YYYY-MM-DD',
  api: 'YYYY-MM-DD',
  displayWithTime: 'YYYY-MM-DD HH:mm:ss'
};

export const PAGINATION_OPTIONS = {
  defaultRowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 25, 50]
};

export const API_ERROR_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  INTERNAL_SERVER_ERROR: 500
};

export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};

export const LOCAL_STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_NAME: 'user_name',
  DEPARTMENT: 'department',
  LANGUAGE: 'language',
  USERNAME: 'username',
  DRAWER_STATE: 'drawerState'
};

export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[\d\s\-+()]+$/,
  ID: /^[A-Za-z0-9]+$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{6,}$/
};